import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { createProduct, updateProduct, getSubCategories } from "./productService";
import VariantSection from "./VariantSection";

function ProductForm({ editData, refreshList, clearEdit }) {
  const [product, setProduct] = useState({
    productName: "",
    subCategoryId: "",
    description: "",
    price: "",
    mrp: "",
    discountPercent: "",
    isTopSelling: false,
    isNewArrival: false,
    isActive: true,
    variants: [],
  });

  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load SubCategories
useEffect(() => {
  const fetchDropdowns = async () => {
    try {
      await loadDropdowns();
    } catch (err) {
      console.error("Dropdown load failed", err);
    }
  };

  fetchDropdowns();
}, []);


// Handle Edit Mode
useEffect(() => {
  if (editData) {
    setProduct({
      ...editData,
      variants: editData.variants || [],
    });
  }
}, [editData]);


  const loadDropdowns = async () => {
    try {
      const res = await getSubCategories();
      const options = res.data.map((s) => ({ value: s.subCategoryId, label: s.subCategoryName }));
      setSubCategories(options);
    } catch (error) {
      console.error("Error loading subcategories", error);
    }
  };

  const handleChange = (e) => {
  const { name, value, type } = e.target;
  setProduct({
    ...product,
    [name]: type === "number" ? (value === "" ? "" : Number(value)) : value,
  });
};

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  if (!product.subCategoryId) {
    toast.error("Please select SubCategory");
    setLoading(false);
    return;
  }

  console.log("Sending Data:", product);

  try {
    if (editData) {
      await updateProduct(editData.productId, product);
      toast.success("Product Updated Successfully");
    } else {
      await createProduct(product);
      toast.success("Product Created Successfully");
    }

    refreshList();
  } catch (error) {
    console.error("API Error:", error.response?.data);
    toast.error(error.response?.data?.message || "Something went wrong!");
  } finally {
    setLoading(false);
  }
};

  return (
  <div className="card shadow-sm rounded-4 p-4">
    <form onSubmit={handleSubmit}>
      <div className="row">

        {/* LEFT SIDE - PRODUCT DETAILS */}
        <div className="col-md-6 border-end">

          <h5 className="mb-3">Product Details</h5>

          <input
            type="text"
            className="form-control mb-3"
            name="productName"
            placeholder="Product Name"
            value={product.productName}
            onChange={handleChange}
            required
          />

          <Select
            options={subCategories}
            value={
              subCategories.find((s) => s.value === product.subCategoryId) || null
            }
            onChange={(selected) =>
              setProduct({
                ...product,
                subCategoryId: selected ? selected.value : "",
              })
            }
            placeholder="Select SubCategory"
            className="mb-3"
          />

          <div className="row">
            <div className="col-md-6">
              <input
                type="number"
                name="price"
                className="form-control mb-3"
                placeholder="Price"
                value={product.price}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <input
                type="number"
                name="mrp"
                className="form-control mb-3"
                placeholder="MRP"
                value={product.mrp}
                onChange={handleChange}
              />
            </div>
          </div>

          <input
            type="number"
            name="discountPercent"
            className="form-control mb-3"
            placeholder="Discount %"
            value={product.discountPercent}
            onChange={handleChange}
          />

          <textarea
            name="description"
            className="form-control mb-3"
            placeholder="Description"
            rows="4"
            value={product.description}
            onChange={handleChange}
          />

          <div className="row">
            <div className="col-md-6">
              <input className="form-check-input" type="checkbox" name="isTopSelling"
                checked={product.isTopSelling}
                onChange={(e) =>
                setProduct({ ...product, isTopSelling: e.target.checked,
               })
              }
             />
             <label className="form-check-label">
    Top Selling Product
  </label>
            </div>

            <div className="col-md-6">
             <input
    className="form-check-input"
    type="checkbox"
    name="isNewArrival"
    checked={product.isNewArrival}
    onChange={(e) =>
      setProduct({
        ...product,
        isNewArrival: e.target.checked,
      })
    }
  />
  <label className="form-check-label">
    New Arrival Product
  </label>
            </div>
          </div>

          
        </div>

        {/* RIGHT SIDE - VARIANTS */}
        <div className="col-md-6">

          <h5 className="mb-3">Product Variants</h5>

          <VariantSection
            variants={product.variants}
            setProduct={setProduct}
            product={product}
          />

        </div>
      </div>

      <div className="text-end mt-4">
        <button
          className="btn btn-success px-4"
          type="submit"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Product"}
        </button>
      </div>
    </form>
  </div>
);
}

export default ProductForm;